import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BhAnalyticsService } from 'src/app/services/_core/bhanalytics/bhanalytics.service';

@Component({
  selector: 'app-reminders-ad-monkeypox',
  templateUrl: './reminders-ad-monkeypox.page.html',
  styleUrls: ['./reminders-ad-monkeypox.page.scss'],
})
export class RemindersAdMonkeypoxPage implements OnInit {

  constructor(
    private modalCtrl: ModalController,
    private analytics: BhAnalyticsService
  ) { }

  ngOnInit() {
    this.analytics.clickEvent('Reminders-ad: Viewed:', '');
  }

  async setReminders() {
    this.dismiss('read');
  }

  dismiss(returnValue) {
    this.analytics.clickEvent('Reminders-ad: Action:', returnValue);
    this.modalCtrl.dismiss(returnValue);
  }

}
